// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"NewsPostPage_Wrapper__XhGx4","NewsPosts":"NewsPostPage_NewsPosts__0xnAd","Pagination":"NewsPostPage_Pagination__i85fO"};